// extracted by mini-css-extract-plugin
export default {"discountsTab":"style--discountsTab--f486d0","title":"style--title--9e5e23","heading":"style--heading--118643"};